import createAPI from 'shared/utils/createAPI';
import * as urlTypes from '../consts/urlType';

export default {
  getCity: data => createAPI.post(urlTypes.GET_CITY, data),
  commitInfo: data => createAPI.post(urlTypes.COMMIT_INFO, data),
  saveInfo: data => createAPI.post(urlTypes.SAVE_INFO, data),
  saveInfoBUI: data => createAPI.post(urlTypes.SAVE_INFO_BUI, data),
  judgeLimit: data => createAPI.post(urlTypes.JUDGELIMIT, data),
};



// WEBPACK FOOTER //
// ./src/pages/newHome/api/index.js